import React, { Component } from 'react';
import { FormattedMessage, injectIntl } from 'react-intl';
import { Table, FormControl } from 'react-bootstrap';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import cx from 'classnames';
import withStyles from 'isomorphic-style-loader/withStyles';

import CustomPagination from '../../CustomPagination';
import Loader from '../../Common/Loader';

import {
  updateCurrencyStatus,
  setBaseCurrency,
  updatePayoutCurrency,
} from '../../../actions/siteadmin/Currency/updateCurrency';
import messages from '../../../locale/messages';
import debounce from '../../../helpers/debounce';

import s from './CurrencyList.css';
import bt from '../../commonStyle.css';

export class CurrencyList extends Component {
  static propTypes = {
    CurrencyData: PropTypes.object,
    updateCurrencyStatus: PropTypes.any.isRequired,
    setBaseCurrency: PropTypes.any.isRequired,
  };

  constructor(props) {
    super(props);
    this.scrollableDivRef = React.createRef();
    this.state = {
      currentPage: 1,
      searchList: '',
    };
  }

  handleSearchChange = debounce(searchList => {
    const {
      CurrencyData: { refetch },
    } = this.props;
    const variables = {
      currentPage: 1,
      searchList,
    };
    this.setState({ currentPage: 1 });
    refetch(variables);
  });

  handleUpdateStatus = async (id, status, symbol) => {
    const {
      updateCurrencyStatus,
      CurrencyData: { refetch },
    } = this.props;
    const { currentPage, searchList } = this.state;
    await updateCurrencyStatus(id, status, symbol, currentPage, searchList);
    refetch();
  };

  handleBaseCurrency = async id => {
    const { setBaseCurrency } = this.props;
    const { currentPage, searchList } = this.state;
    await setBaseCurrency(id, currentPage, searchList);
  };

  paginationData = currentPage => {
    const {
      CurrencyData: { refetch },
    } = this.props;
    const variables = { currentPage };
    this.setState({ currentPage });
    if (this.scrollableDivRef.current) {
      this.scrollableDivRef.current.scrollTop = 0;
    }
    refetch(variables);
  };

  handlePayoutCurrency = async ({ id, isPayoutCurrency, symbol }) => {
    const {
      updatePayoutCurrency,
      CurrencyData: { refetch },
    } = this.props;
    await updatePayoutCurrency({ id, isPayoutCurrency, symbol });
    refetch();
  };

  render() {
    const { CurrencyData, loading } = this.props;
    const { formatMessage } = this.props.intl;
    const { currentPage } = this.state;

    return (
      <div className={cx(s.widthInner, 'bgBlackTwo')}>
        <div className={bt.tableTopGrpContainer}>
          <div className={s.searchInput}>
            <FormControl
              type="text"
              placeholder={formatMessage(messages.searchOnly)}
              onChange={e =>
                this.handleSearchChange(e.target && e.target.value)
              }
              className={bt.formControlInput}
            />
          </div>
        </div>
        <div className="clearfix" />
        {loading && (
          <div>
            <Loader type="circle" />
          </div>
        )}
        {!loading && (
          <div
            className={cx(
              s.tableCss,
              'tableCss',
              'tableSticky',
              'NewResponsiveTable',
              'topScrollbarTable',
            )}
            ref={this.scrollableDivRef}
          >
            <Table className={cx('table', 'topScrollbarTableContent')}>
              <thead>
                <tr>
                  <th scope="col">
                    <FormattedMessage {...messages.id} />
                  </th>
                  <th scope="col">
                    <FormattedMessage {...messages.symbol} />
                  </th>
                  <th scope="col">
                    <FormattedMessage {...messages.baseCurrency} />
                  </th>
                  <th scope="col">
                    <FormattedMessage {...messages.status} />
                  </th>
                  <th scope="col">
                    <FormattedMessage {...messages.enableDisable} />
                  </th>
                  <th scope="col">
                    <FormattedMessage {...messages.setBaseCurrency} />
                  </th>
                  <th scope="col">
                    <FormattedMessage {...messages.payoutCurrency} />
                  </th>
                </tr>
              </thead>
              <tbody>
                {CurrencyData?.getCurrency?.currencyList?.length > 0 &&
                  CurrencyData?.getCurrency?.currencyList?.map(
                    (item, index) => (
                      <tr key={index}>
                        <td data-label={formatMessage(messages.id)}>
                          {item?.id}
                        </td>
                        <td data-label={formatMessage(messages.symbol)}>
                          {item?.symbol}
                        </td>
                        {item?.isBaseCurrency == 1 && (
                          <td data-label={formatMessage(messages.baseCurrency)}>
                            <FormattedMessage {...messages.active} />
                          </td>
                        )}
                        {item?.isBaseCurrency == 0 && (
                          <td
                            data-label={formatMessage(messages.baseCurrency)}
                          />
                        )}
                        {item?.isEnable && (
                          <td data-label={formatMessage(messages.status)}>
                            <FormattedMessage {...messages.Enabled} />
                          </td>
                        )}
                        {!item?.isEnable && (
                          <td data-label={formatMessage(messages.status)}>
                            <FormattedMessage {...messages.Disabled} />
                          </td>
                        )}
                        <td data-label={formatMessage(messages.enableDisable)}>
                          {' '}
                          <a
                            href="javascript:void(0)"
                            onClick={() =>
                              this.handleUpdateStatus(
                                item?.id,
                                item?.isEnable,
                                item?.symbol,
                              )
                            }
                          >
                            {item?.isEnable && (
                              <span>
                                {' '}
                                <FormattedMessage {...messages.Disable} />{' '}
                              </span>
                            )}

                            {!item?.isEnable && (
                              <span>
                                {' '}
                                <FormattedMessage {...messages.Enable} />{' '}
                              </span>
                            )}
                          </a>
                        </td>
                        <td
                          data-label={formatMessage(messages.setBaseCurrency)}
                        >
                          <span>
                            {!item?.isBaseCurrency && item?.isEnable && (
                              <a
                                href="javascript:void(0)"
                                onClick={() =>
                                  this.handleBaseCurrency(item?.id)
                                }
                              >
                                <FormattedMessage {...messages.setBase} />
                              </a>
                            )}
                          </span>
                        </td>
                        <td data-label={formatMessage(messages.payoutCurrency)}>
                          <span>
                            {!item?.isPayoutCurrency && item?.isEnable && (
                              <a
                                href="javascript:void(0)"
                                onClick={() =>
                                  this.handlePayoutCurrency({
                                    id: item?.id,
                                    isPayoutCurrency: item?.isPayoutCurrency,
                                    symbol: item?.symbol,
                                  })
                                }
                              >
                                <FormattedMessage
                                  {...messages.setPayoutCurrency}
                                />
                              </a>
                            )}
                            {item.isPayoutCurrency && (
                              <FormattedMessage {...messages.active} />
                            )}
                          </span>
                        </td>
                      </tr>
                    ),
                  )}
                {CurrencyData?.getCurrency?.currencyList?.length == 0 && (
                  <tr>
                    <td colSpan="12" className={s.noRecords}>
                      <FormattedMessage {...messages.noResult} />
                    </td>
                  </tr>
                )}
              </tbody>
            </Table>
          </div>
        )}
        {CurrencyData?.getCurrency?.currencyList?.length > 0 && (
          <div className={cx(bt.space5, bt.spaceTop5)}>
            <CustomPagination
              total={CurrencyData.getCurrency.count}
              currentPage={currentPage}
              defaultCurrent={1}
              defaultPageSize={10}
              change={this.paginationData}
              paginationLabel={formatMessage(messages.currencies)}
            />
          </div>
        )}
      </div>
    );
  }
}

const mapDispatch = {
  updateCurrencyStatus,
  setBaseCurrency,
  updatePayoutCurrency,
};

const mapState = state => ({
  loading: state.intl.loading,
});

export default injectIntl(
  withStyles(s, bt)(connect(mapState, mapDispatch)(CurrencyList)),
);
